import { Form as FormikForm } from 'formik';
import styled from 'styled-components/macro';
import {
  focusRing,
  fontSize,
  fontWeight,
  layout,
  radius,
  shadow,
  space,
} from '../../../theme/tokens';
import * as common from '../../common/elements/Form';

export const Form = styled(FormikForm)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  /* flex-start, not center, so overflowing content stays scrollable */
  justify-content: flex-start;
  width: calc(100% - 2 * ${layout.gutter});
  /* keep tall forms inside the viewport on small screens */
  max-height: calc(100vh - 2 * ${layout.gutter});
  overflow-y: auto;
  background: ${({ theme }) => theme.appBackground};
  border-radius: ${radius.lg};
  box-shadow: ${shadow.lg};
  ${common.ModalScreenWidthMQs}
`;

export const UploadButton = styled(common.Button).attrs(() => ({
  as: 'label',
}))``;

export const ImageInput = styled.input`
  display: none;
`;
export const ImagePreview = styled.img`
  margin: ${space[4]};
  border-radius: ${radius.md};
  /* preview thumbnail size */
  height: 14.4rem;
  width: 14.4rem;
  object-fit: cover;
`;

export const ImportButton = styled.button`
  min-height: ${layout.touchTarget};
  margin: ${space[2]} 0;
  padding: 0 ${space[3]};
  font-family: inherit;
  font-weight: ${fontWeight.heavy};
  font-size: ${fontSize.md};
  text-decoration: none;
  border-radius: ${radius.md};
  background: none;
  border: none;
  color: ${({ theme }) => theme.textDark};
  &:hover {
    text-decoration: underline;
    color: ${({ theme }) => theme.buttonPrimary};
    cursor: pointer;
  }
  ${focusRing}
`;

export * from '../../common/elements/Form';
export * from '../../common/elements/Staff';
